import {faCog} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC, useMemo} from 'react';
import {Link, NavLink} from 'react-router-dom';

import {mainState} from '../AppMainState';
import {logOverviewLink, projectDashboardLink, settingsLink} from '../routing/AppRoutes';
import {toJS} from 'mobx';
import {ProjectListDto} from '../swagger';

export const SidebarProjectEntry: FC<{ p: ProjectListDto }> = observer(({p}) => {
  const isProjectEditable = p.userId == mainState.currentUser?.userId;

  return <div>
    <div
      className="bg-m-gray-3 flex font-bold items-center justify-between mb-3 px-4 py-2 rounded">
      <NavLink
        className="w-full"
        to={projectDashboardLink(p.projectId!)}
      >
        {p.name}
      </NavLink>
      {isProjectEditable && !mainState.isDemoUser && <Link className="btn btn-sm" to={settingsLink(p.projectId!)}>
        <FontAwesomeIcon className="fill-current text-m-gray-6" icon={faCog} />
      </Link>}
    </div>
    <ul id="logs">
      {p.logs!.map((l) => (
        <li className="flex items-center py-1 pl-3 hover:bg-m-gray-3" key={'sidebarlog' + l.logId}>
          <span className="list-item-bullet mr-4"></span>
          <NavLink
            className="inline-block w-full"
            to={logOverviewLink(l.logId!)}>
            {l.name}
          </NavLink>
        </li>
      ))}
    </ul>
  </div>;
});
